import React, { useState, useEffect } from "react";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import Loading from "../../components/Laoding";

import { toast } from "react-toastify";
import { send } from "emailjs-com";

import AOS from "aos";

export default function HubungiKami() {
  const [isActive, setIsActive] = useState("hubungikami");
  const [sender_name, setSender_Name] = useState("");
  const [sender_email, setSender_Email] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleName = (e) => {
    setSender_Name(e.target.value);
  };
  const handleEmail = (e) => {
    setSender_Email(e.target.value);
  };
  const handleMessage = (e) => {
    setMessage(e.target.value);
  };

  const sendMail = (e) => {
    e.preventDefault();
    setIsLoading(true);
    send(
      "service_be14n18",
      "template_nb7ihnb",
      { sender_name, sender_email, message },
      "oD5ojcr0ahADNMo4G"
    )
      .then((res) => {
        setIsLoading(false);
        toast.success("Pesan berhasil dikirim");
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        toast.success("Pesan gagal dikirim");
      });
  };

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <>
      {isLoading && <Loading />}
      <Navbar isActive={isActive} />
      <div className="container pt-5" data-aos="fade-up">
        <div className="mainContentHubungiKami pt-3">
          <h1 className="text-center text-danger fw-bold pt-5 pb-3">
            Hubungi Kami
          </h1>
          <form onSubmit={sendMail}>
            <div className="mb-3">
              <label for="nameFrom" class="form-label">
                Nama :
              </label>
              <input
                type="name"
                class="form-control"
                name="sender_name"
                value={sender_name}
                onChange={handleName}
                placeholder="Nama"
              />
              {/* <label for="emailFrom">Nama anda</label>
              <input
                type="text"
                name="sender_name"
                value={sender_name}
                onChange={handleName}
                placeholder="Name"
              /> */}
            </div>
            <div className="mb-3">
              <label for="emailFrom" className="form-label">
                Email :
              </label>
              <input
                type="name"
                class="form-control"
                name="sender_email"
                value={sender_email}
                onChange={handleEmail}
                placeholder="example@gmail.com"
              />
            </div>
            <div class="mb-3">
              <label for="exampleFormControlTextarea1" class="form-label">
                Subject :
              </label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                name="message"
                value={message}
                onChange={handleMessage}
                placeholder="Subject"
              ></textarea>
            </div>
            {/* <div className="mb-3">
              <label for="emailF" className="form-label">
                Nomor HP
              </label>
              <input
                type="name"
                class="form-control"
                name="message"
                value={message}
                onChange={handleMessage}
                placeholder="Nomor Hp"
              />
            </div> */}
            <button type="submit" className="btn btn-danger">
              Kirim
            </button>
          </form>
        </div>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 250">
        <path
          fill="#D30032"
          fill-opacity="1"
          d="M0,224L30,234.7C60,245,120,267,180,234.7C240,203,300,117,360,117.3C420,117,480,203,540,245.3C600,288,660,288,720,250.7C780,213,840,139,900,128C960,117,1020,171,1080,208C1140,245,1200,267,1260,229.3C1320,192,1380,96,1410,48L1440,0L1440,320L1410,320C1380,320,1320,320,1260,320C1200,320,1140,320,1080,320C1020,320,960,320,900,320C840,320,780,320,720,320C660,320,600,320,540,320C480,320,420,320,360,320C300,320,240,320,180,320C120,320,60,320,30,320L0,320Z"
        ></path>
      </svg>
      <Footer />
    </>
  );
}
